/** Asset paths served from /public — keep in sync with apps/web/public/assets/. */
export const ASSETS = {
  hero: '/assets/hero.png',
  /** Used as the in-page arena scene background (the "you have arrived" shot). */
  arena: '/assets/arena.png',
  /** Used as the landing pathway card preview for "Enter the Arena". */
  arenaCard: '/assets/arena-card.png',
  worldview: '/assets/worldview.png',
  watch: '/assets/watch.png',
  craft: '/assets/craft.png',
  transitionArena: '/assets/transition.mp4',
  transitionWorldview: '/assets/transition-worldview.mp4',
} as const;

/** Cinematic transition timings, in ms. Centralized so devs can tune the choreography. */
export const TRANSITION = {
  /** Time between click and the video crossfade. Drop animation runs in this window. */
  DROP_DURATION_MS: 900,
  /** Time between video start and fade-to-black trigger. */
  VIDEO_DURATION_MS: 5600,
  /** Time the fade-to-black overlay takes to reach opacity 1. */
  FADE_TO_BLACK_MS: 1500,
  /** Wake-up clears after this delay (matches the fade-from-black duration). */
  WAKE_CLEANUP_MS: 1700,
} as const;
